import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ dataSource }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    indexAxis: "y",
    responsive: true,
    scales: {
      x: {
        ticks: {
          precision: 0,
          color: "#d7d7d7",
          beginAtZero: true,
          userCallback: function (label, index, labels) {
            // when the floored value is the same as the value we have a whole number
            if (Math.floor(label) === label) {
              return label;
            }
          },
        },
        grid: {
          color: "#4b4b4b",
        },
      },
      y: {
        ticks: {
          precision: 0,
          color: "#d5d5d5",
          beginAtZero: true,
          userCallback: function (label, index, labels) {
            // when the floored value is the same as the value we have a whole number
            if (Math.floor(label) === label) {
              return label;
            }
          },
        },
        grid: {
          color: "#4b4b4b",
        },
      },
    },
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
      },
    },
  };
  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true)
  const colors = [themeColor, "#f0ad4e", "#5cb85c", "#d9534f", "#5bc0de"];

  // labels will be the date of data source if it exist only one date in the label
  useEffect(() => {
    if (dataSource && dataSource.length) {
      const labels = [];

      const datasets = [];

      const datas = [];
      dataSource.map((item, index) => {
        // set item.firstname as label
        if (!labels.includes(item.team)) {
          labels.push(item.team);
          datas.push(item.count);
        }
      });
      datasets.push({
        label: labels,
        data: datas,
        backgroundColor: colors,
        borderColor: colors,
      });

      const data = {
        labels,
        datasets: datasets,
      };
      setData(data);
    } else {
      setData(null);
    }
    setLoading(false)
  }, [dataSource]);

  return !loading ? (
    <div style={{ position: "relative", height: "270px", width: "100%" }}>
      {data ? <Bar options={options} data={data} /> : null}
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
